import AreaTipoDivergenciaEnum from '../../AreaTipoDivergenciaEnum';
import { useBuildFinalStepTemplate } from '../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../template/UseBuildSubmitHandler';
import TipoDivergenciasKey from '../../TipoDivergenciasKey';
import { TipoDivergenciaComponent } from '../../TiposDeDivergencias';


const FaltaGabarito: TipoDivergenciaComponent = ({
  onBack,
  onSetStep,
}) => {


  const key = TipoDivergenciasKey.FALTA_GABARITO;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);


  return useBuildFinalStepTemplate({

    area: AreaTipoDivergenciaEnum.CORTE,
    loading: loadingSave || loadingTipoDivergencia,
    onBack,
    onSetStep: handleSubmit,
    tipoDivergencia: 'Gabarito não seguiu junto a ordem',
  });

};

export default FaltaGabarito;
